module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.93fe8f34.woff2";